<template>
	<vs-prompt
		:active.sync="activeProp"
		:buttons-hidden="true"
		:title="$t('changeStatus')"
		:cancel-text="$t('cancel')"
		button-cancel="filled"
		color="warning"
		class="marginality-popup"
		@cancel="close"
		@close="close"
		@accept="confirm"
	>
		<div class="con-exemple-prompt">
			<div class="content mb-2">
				<vs-alert color="primary" class="mb-2 p-2" v-html="$t('forceChangeStatus')"/>
			</div>

			<div class="mt-2">

				<label for="" class="vs-input--label">{{ $t('ticketStatus') }}</label>
				<v-select
					v-model="status"
					:reduce="item => item.status"
					:options="availableOrderStatuses"
					:placeholder="$t('ticketStatus')"
					label="label"
					:clearable="false"
					class="single-row-select w-full"
				/>
			</div>
			<div class="mt-2">

				<label for="" class="vs-input--label">{{ $t('activeMilestone') }}</label>
				<v-select
					v-model="active_milestone_id"
					:reduce="item => item.value"
					:options="availableStages"
					:placeholder="$t('activeMilestone')"
					label="label"
					:clearable="false"
					class="single-row-select w-full"
				/>
			</div>
			<div class="mt-2">

				<label for="" class="vs-input--label">{{ $t('activeMilestoneStatus') }}</label>
				<v-select
					v-model="active_milestone_status"
					:reduce="item => item.status"
					:options="availableStageStatuses"
					:placeholder="$t('activeMilestoneStatus')"
					label="label"
					:clearable="false"
					class="single-row-select w-full"
				/>
			</div>

			<div class="flex justify-center mt-8">
				<vs-button class="mr-4" color="warning" @click="confirm">{{
						$t("confirm")
					}}</vs-button>

				<vs-button color="#9a9a9a" type="flat" @click="close">{{
						$t("cancel")
					}}</vs-button>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
import vSelect from 'vue-select';
import databaseManager from "@/mixins/databaseManager";
export default {
	name: "ForceChangeStatus",
	props: {
		active: { default: false, type: Boolean },
		model: { type: Object },
		stages: { type: Array },
	},
	components: {
		vSelect
	},
	mixins: [databaseManager],
	data() {
		return {
			status: null,
			active_milestone_id: null,
			active_milestone_status: null,
		};
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		},
		availableOrderStatuses: function() {
			return [
				{
					status: "new",
					label: this.$t('new'),
				},
				{
					status: "client_not_answer",
					label: this.$t('clientNotAnswer'),
				},
				{
					status: "archive",
					label: this.$t('archive'),
				},
				{
					status: "processing",
					label: this.$t('processing'),
				},
				{
					status: "offer_sent",
					label: this.$t('offerSent'),
				},
				{
					status: "waiting_payment",
					label: this.$t('waitingPayment'),
				},
				{
					status: "waiting_author",
					label: this.$t('waitingAuthor'),
				},
				{
					status: "in_progress",
					label: this.$t('inProgress'),
				},
				{
					status: "work_long_term",
					label: this.$t('workLongTerm'),
				},
				{
					status: "waiting_approve",
					label: this.$t('waitingApprove'),
				},
				{
					status: "completed",
					label: this.$t('completed'),
				},
				{
					status: "additional_sale",
					label: this.$t('additionalSale'),
				},
				{
					status: "failed",
					label: this.$t('failed'),
				},
				{
					status: "failed_with_payout",
					label: this.$t('failedWithPayout'),
				},
				{
					status: "deleted",
					label: this.$t('deleted'),
				},
			];
		},
		availableStages: function() {
			const result = [];
			let index = 1;
			this.stages.forEach(function (stage) {
				result.push({
					value: stage.id,
					label: `Stage ${index}`
				});
				++index;
			})
			return result;
		},

		availableStageStatuses: function() {
			const statusMapping = {
				new: [
					{
						status: "new",
						label: this.$t('new'),
					}
				],
				client_not_answer: [
					{
						status: "new",
						label: this.$t('new'),
					},
					{
						status: "waiting_payment",
						label: this.$t('waitingPayment'),
					},
					{
						status: "in_progress",
						label: this.$t('inProgress'),
					},
				],
				processing: [
					{
						status: "new",
						label: this.$t('new'),
					},
				],
				offer_sent: [
					{
						status: "new",
						label: this.$t('new'),
					},
				],
				waiting_payment: [
					{
						status: "new",
						label: this.$t('new'),
					},
					{
						status: "waiting_payment",
						label: this.$t('waitingPayment'),
					},
				],
				waiting_author: [
					{
						status: "in_progress",
						label: this.$t('inProgress'),
					},
				],
				in_progress: [
					{
						status: "in_progress",
						label: this.$t('inProgress'),
					},
				],
				waiting_approve: [
					{
						status: "in_progress",
						label: this.$t('inProgress'),
					},
				],
				completed: [
					{
						status: "completed",
						label: this.$t('completed'),
					},
				],
				additional_sale: [
					{
						status: "completed",
						label: this.$t('completed'),
					},
				],
				failed: [
					{
						status: "failed",
						label: this.$t('failed'),
					},
				],
				failed_with_payout: [
					{
						status: "failed_with_payout",
						label: this.$t('failedWithPayout'),
					}
				],
			}
			return statusMapping.hasOwnProperty(this.status) ? statusMapping[this.status] : [];
		},
	},
	watch: {
		model: {
			handler: function (newValue) {
				this.initOrder(newValue)
			},
			deep: true,
		},
		stages: {
			handler: function (newValue) {
				this.initStages(newValue)
			},
			deep: true,
		},
		status: function () {
			const vm = this;
			const hasCurrentStatus = this.availableStageStatuses.find(function (item) {
				item.status === vm.active_milestone_status;
			});
			if(!hasCurrentStatus) {
				vm.active_milestone_status = this.availableStageStatuses[0] ? this.availableStageStatuses[0].status : null;
			}
		}
	},
	methods: {
		async confirm() {
			///send api request
			await this.setStatus();
			this.$emit("confirm");
			this.activeProp = false;
		},
		async setStatus() {
			const id = this.updatedTicketId;
			const {
				status,
				active_milestone_id,
				active_milestone_status
			} = this;
			return await this.dbSetTicketStatus(this.model.id, {
				status,
				active_milestone_id,
				active_milestone_status
			});
		},
		close() {
			this.activeProp = false;
			this.$emit("cancel");
		},
		initOrder: function(newValue) {

			this.status = newValue.status;
		},
		initStages: function (newValue) {
			let i = newValue.length;
			do {
				if(newValue[i - 1].status === 'completed') {
					break;
				}
				i -= 1;
			} while (i > 0 && newValue[i].status === 'new');
			this.active_milestone_id = newValue[i].id;
			this.active_milestone_status = newValue[i].status;
		}
	},
	mounted() {
		this.initStages(this.stages);
		this.initOrder(this.model);
	}
};
</script>

<style lang="scss">
.marginality-popup {
	&.con-vs-dialog {
		z-index: 54000;
	}
	.vs-dialog {
		max-width: 350px;
	}
}
</style>
